import type { IconProps } from '@/components/CustomIcon/types';

export const BellIcon = ({ size = 18, className, ...props }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.7057 13.7275C15.7026 12.4998 14.9944 11.8748 14.9944 8.48999C14.9944 5.39038 13.4116 4.28608 12.1088 3.74976C11.9358 3.67866 11.7729 3.51538 11.7202 3.33765C11.4916 2.55991 10.851 1.87476 9.99946 1.87476C9.1479 1.87476 8.50688 2.5603 8.28071 3.33843C8.22797 3.51811 8.06508 3.67866 7.89204 3.74976C6.58774 4.28686 5.00649 5.38726 5.00649 8.48999C5.00454 11.8748 4.29634 12.4998 3.29321 13.7275C2.87759 14.2361 3.24165 14.9998 3.9686 14.9998H16.0342C16.7573 14.9998 17.119 14.2337 16.7057 13.7275Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14.999V15.624C12.5 16.2871 12.2366 16.9229 11.7678 17.3918C11.2989 17.8606 10.663 18.124 10 18.124C9.33696 18.124 8.70107 17.8606 8.23223 17.3918C7.76339 16.9229 7.5 16.2871 7.5 15.624V14.999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
